import { CircleDot, Swords, Target, Trophy } from 'lucide-react';

// Sport icon mapping (consistent with AdminSports)
export const SPORT_ICONS = { 'soccer': CircleDot, 'rugby': Swords, 'gaelic-football': Target, 'hurling-camogie': Swords };

export const SportIcon = ({ sport, className = "w-4 h-4" }) => {
  const Icon = SPORT_ICONS[sport?.slug] || Trophy;
  return <Icon className={className} />;
};

// Convert ISO/UTC datetime to local datetime-local input format
export const toLocalDatetimeInput = (isoString) => {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// Normalize YouTube URLs to standard format
export const normalizeYouTubeUrl = (url) => {
  if (!url) return url;
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/live\/|youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/,
    /^([a-zA-Z0-9_-]{11})$/
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return `https://www.youtube.com/watch?v=${match[1]}`;
  }
  return url;
};
